import type { GetCountriesAndCurrenciesQuery } from './graphql';
import { useGetCountriesAndCurrenciesQuery } from './graphql';

export type CountryItem = NonNullable<
  NonNullable<GetCountriesAndCurrenciesQuery['countries']>['items']
>[number];

export type CurrencyItem = NonNullable<
  NonNullable<GetCountriesAndCurrenciesQuery['currencies']>['items']
>[number];

const EMPTY_COUNTRIES: readonly CountryItem[] = [];
const EMPTY_CURRENCIES: readonly CurrencyItem[] = [];

export const useCountriesAndCurrencies = () => {
  const { data, loading, error } = useGetCountriesAndCurrenciesQuery({
    fetchPolicy: 'cache-first',
  });

  return {
    countries: data?.countries?.items ?? EMPTY_COUNTRIES,
    currencies: data?.currencies?.items ?? EMPTY_CURRENCIES,
    loading,
    error,
  };
};
